import {SET_OPINION, SET_OPINIONS, HATE_OPINION, UNHATE_OPINION, IGNORE_OPINION, UNIGNORE_OPINION, LOADING_DATA, DELETE_OPINION, POST_OPINION, SUBMIT_WRECK } from '../types'

const initialState = {
    wrecks: [],
    wreck: {},
    loading: false
}

export default function(state = initialState, action){
    switch(action.type){
        case LOADING_DATA:
            return {
                ...state,
                loading: true
            }
        case SET_OPINIONS:
            return {
                ...state,
                wrecks: action.payload,
                loading: false
            }
        case SET_OPINION:
            return {
                ...state,
                wreck: action.payload
            }
        case IGNORE_OPINION:
        case UNIGNORE_OPINION:
            let index = state.wrecks.findIndex((wreck) => wreck.wreckID === action.payload.wreckID);
            state.wrecks[index] = action.payload;
            if(state.wreck.wreckID === action.payload.wreckID){
                state.wreck = {...state.wreck, ...action.payload};
            }
            return {
                ...state
            }
        case HATE_OPINION:
        case UNHATE_OPINION:
            let index3 = state.wrecks.findIndex((wreck) => wreck.wreckID === action.payload.wreckID);
            state.wrecks[index3] = action.payload;
            if(state.wreck.wreckID === action.payload.wreckID){
                state.wreck = {...state.wreck, ...action.payload};
            }
            return {
                ...state
            }
        case DELETE_OPINION:
            let index1 = state.wrecks.findIndex((wreck) => wreck.wreckID === action.payload);
            state.wrecks.splice(index1, 1);
            return {
                ...state
            }
        case POST_OPINION:
            return {
                ...state,
                wrecks: [
                    action.payload,
                    ...state.wrecks
                ]
            }
            case SUBMIT_WRECK:
                let index2 = state.wrecks.findIndex(          
                  wreck => wreck.wreckID === action.payload.wreckID         
                );
              /////// Looks for the wreck, just like in "like" and "unlike" reducers
                let updatedWrecks = JSON.parse(JSON.stringify(state.wrecks));
           ///// deep copy of the array - simply spreading it won't work
                updatedWrecks[index2].commentCount += 1;         
                return {         
                  ...state,        
                  wrecks: updatedWrecks,         
                  wreck: {         
                    ...state.wreck,          
                    comments: [action.payload.comment, ...state.wreck.comments],      
                    commentCount: state.wreck.commentCount + 1        
                  }       
                };
        default: 
            return state;
    }
} 